import { render } from "./Barview.vue?vue&type=template&id=26527ae0"
import script from "./Barview.vue?vue&type=script&lang=js"
export * from "./Barview.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Gitlab-Runner\\builds\\bssYrz32\\0\\as\\WebServerVisualization\\webclient\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__